import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { SliceZone, usePrismicDocumentByUID } from "@prismicio/react";
import * as prismicH from "@prismicio/helpers";

import { components } from "../slices";
import { Layout } from "../components/Layout";
import { BackButton } from "../components/BackButton";
import { NotFound } from "./NotFound";
import { getCurrentLocale } from "../locale";

/**
 * Blog post page component
 */
export const Post = () => {
  const { uid } = useParams();

  const [prismicDoc, prismicDocState] = usePrismicDocumentByUID("post", uid, 
  {lang: getCurrentLocale()});

  const notFound = prismicDocState.state === "failed";
const [body, setBody] = React.useState('')
  useEffect(() => {
    if (prismicDocState.state === "failed") {
      console.warn(
        "Blog post document was not found. Make sure it exists in your Prismic repository"
      );
    }
  }, [prismicDocState.state]);

  React.useEffect(() => {
   
    if(prismicDoc?.data?.body) {
      console.warn(JSON.stringify(prismicDoc?.data?.body))
      const sanitized = replaceVervoWithTaskyCal(prismicDoc?.data?.body)
  
        setBody(sanitized)
    }
   
  }, [prismicDoc?.data?.body])

  // Return the page if a document was retrieved from Prismic
  if (prismicDoc && body?.length) {
    const title = prismicH.asText(prismicDoc.data.title) || "Untitled";

    return (
      <Layout wrapperClass="main" seoTitle={title}>
        <div className="outer-container">
          <BackButton />
          <h1 >{title.replace('Vervo', 'TaskyCal')}</h1>
        </div>
        <SliceZone slices={body} components={components} />
      </Layout>
    );
  } else if (notFound) {
    return <NotFound />;
  }

  return null;
};

function replaceVervoWithTaskyCal(data) {
  if (typeof data === 'object' && data !== null) {
    if (Array.isArray(data)) {
      return data.map(replaceVervoWithTaskyCal);
    } else {
      const newData = {};
      for (const key in data) {
        if (typeof data[key] === 'string') {
          newData[key] = data[key].replace(/Vervo/g, 'TaskyCal');
        } else {
          newData[key] = replaceVervoWithTaskyCal(data[key]);
        }
      }
      return newData;
    }
  } else {
    return data
  }
}




